<script>
  import { page } from "$app/stores";
  
  // Import the logo from the static folder
  const logoUrl = '/uzakitu-logo.png';
  
  export let size = "";
  export let className = "";

  // Logo links to dashboard if in dashboard, otherwise to homepage (which is the shop)
  $: isInDashboard = $page.url.pathname.startsWith('/dashboard');
  $: hrefLink = isInDashboard ? '/dashboard' : '/';
</script>

<div class={`${size === "sm" ? "w-14" : "w-20"} h-auto ${className}`}>
  <!-- //logo -->
  <a href={hrefLink} class="block w-full h-full">
    <img 
      src={logoUrl} 
      alt="Uzakitu Logo" 
      class="w-full h-full object-contain"
      loading="lazy"
    />
  </a>
</div>
